module.exports = __webpack_public_path__ + "img/Penguin2.97a52b74.png";